import { resolveComponent as _resolveComponent, createVNode as _createVNode, withCtx as _withCtx, createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, toDisplayString as _toDisplayString, vShow as _vShow, withDirectives as _withDirectives, withKeys as _withKeys, renderList as _renderList, Fragment as _Fragment, createTextVNode as _createTextVNode, createBlock as _createBlock } from "vue"

const _hoisted_1 = {
  key: 0,
  class: "spin"
}
const _hoisted_2 = { key: 1 }
const _hoisted_3 = { slot: "content" }
const _hoisted_4 = ["src"]

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_ion_icon = _resolveComponent("ion-icon")!
  const _component_ion_button = _resolveComponent("ion-button")!
  const _component_ion_buttons = _resolveComponent("ion-buttons")!
  const _component_ion_label = _resolveComponent("ion-label")!
  const _component_ion_segment_button = _resolveComponent("ion-segment-button")!
  const _component_ion_segment = _resolveComponent("ion-segment")!
  const _component_ion_toolbar = _resolveComponent("ion-toolbar")!
  const _component_ion_header = _resolveComponent("ion-header")!
  const _component_ion_spinner = _resolveComponent("ion-spinner")!
  const _component_ion_item = _resolveComponent("ion-item")!
  const _component_ion_accordion = _resolveComponent("ion-accordion")!
  const _component_ion_accordion_group = _resolveComponent("ion-accordion-group")!
  const _component_ion_list = _resolveComponent("ion-list")!
  const _component_ion_title = _resolveComponent("ion-title")!
  const _component_ion_searchbar = _resolveComponent("ion-searchbar")!
  const _component_ion_modal = _resolveComponent("ion-modal")!
  const _component_ion_content = _resolveComponent("ion-content")!

  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _createVNode(_component_ion_header, null, {
      default: _withCtx(() => [
        _createVNode(_component_ion_toolbar, { style: {"--min-height":"36px"} }, {
          default: _withCtx(() => [
            _createVNode(_component_ion_buttons, { slot: "start" }, {
              default: _withCtx(() => [
                _createVNode(_component_ion_button, {
                  slot: "icon-only",
                  onClick: _cache[0] || (_cache[0] = ($event: any) => (_ctx.closeModal()))
                }, {
                  default: _withCtx(() => [
                    _createVNode(_component_ion_icon, { icon: _ctx.arrowBack }, null, 8, ["icon"])
                  ]),
                  _: 1
                })
              ]),
              _: 1
            }),
            _createVNode(_component_ion_segment, {
              color: "primary",
              mode: "ios",
              modelValue: _ctx.section,
              "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((_ctx.section) = $event)),
              scrollable: ""
            }, {
              default: _withCtx(() => [
                _createVNode(_component_ion_segment_button, { value: 1 }, {
                  default: _withCtx(() => [
                    _createVNode(_component_ion_label, { class: "ion-text-wrap" }, {
                      default: _withCtx(() => _cache[7] || (_cache[7] = [
                        _createElementVNode("p", null, "CV | Cover letter", -1)
                      ])),
                      _: 1
                    })
                  ]),
                  _: 1
                })
              ]),
              _: 1
            }, 8, ["modelValue"])
          ]),
          _: 1
        })
      ]),
      _: 1
    }),
    _createVNode(_component_ion_content, { fullscreen: true }, {
      default: _withCtx(() => [
        (_ctx.loading)
          ? (_openBlock(), _createElementBlock("div", _hoisted_1, [
              _createVNode(_component_ion_spinner)
            ]))
          : (_openBlock(), _createElementBlock("div", _hoisted_2, [
              _withDirectives(_createElementVNode("div", null, [
                _createVNode(_component_ion_list, null, {
                  default: _withCtx(() => [
                    _createVNode(_component_ion_item, {
                      onClick: _cache[2] || (_cache[2] = ($event: any) => (_ctx.openChatbotModal())),
                      button: "",
                      detail: ""
                    }, {
                      default: _withCtx(() => [
                        _createVNode(_component_ion_label, null, {
                          default: _withCtx(() => _cache[8] || (_cache[8] = [
                            _createElementVNode("h2", null, [
                              _createElementVNode("b", null, "1. Generate CV bullet points / CL claims")
                            ], -1)
                          ])),
                          _: 1
                        })
                      ]),
                      _: 1
                    }),
                    _createVNode(_component_ion_accordion_group, null, {
                      default: _withCtx(() => [
                        _createVNode(_component_ion_accordion, { style: {"--min-height":"24px"} }, {
                          default: _withCtx(() => [
                            _createVNode(_component_ion_item, { slot: "header" }, {
                              default: _withCtx(() => [
                                _createVNode(_component_ion_label, null, {
                                  default: _withCtx(() => _cache[9] || (_cache[9] = [
                                    _createElementVNode("h2", null, [
                                      _createElementVNode("b", null, "2. Transform CV headlines")
                                    ], -1)
                                  ])),
                                  _: 1
                                })
                              ]),
                              _: 1
                            }),
                            _createElementVNode("div", _hoisted_3, [
                              _createElementVNode("img", {
                                style: {"width":"100%"},
                                src: _ctx.getProxyImgLink('https://docs.google.com/presentation/d/1PcPhzYb77IrgcrfWrPNKf3VUhrsW3ENq4D3xuKZvfaw/export/jpeg?id=1PcPhzYb77IrgcrfWrPNKf3VUhrsW3ENq4D3xuKZvfaw&pageid=g24552ba4bf2_0_30')
                              }, null, 8, _hoisted_4)
                            ])
                          ]),
                          _: 1
                        })
                      ]),
                      _: 1
                    }),
                    _createVNode(_component_ion_item, {
                      href: _ctx.user['profileDoc'] || 'https://docs.google.com/document/d/1k7worydNb-ntGs9gySuWC9-p35tl163mpMuR5gX_ZIA/edit',
                      target: "_blank",
                      button: "",
                      detail: ""
                    }, {
                      default: _withCtx(() => [
                        _createVNode(_component_ion_label, null, {
                          default: _withCtx(() => [
                            _cache[10] || (_cache[10] = _createElementVNode("h2", null, [
                              _createElementVNode("b", null, "3. Finish")
                            ], -1)),
                            _createElementVNode("p", null, [
                              _createElementVNode("small", null, "CV and Cover Letter templates shared with your Gmail: " + _toDisplayString(_ctx.user.email), 1)
                            ])
                          ]),
                          _: 1
                        })
                      ]),
                      _: 1
                    }, 8, ["href"]),
                    _createVNode(_component_ion_accordion_group, null, {
                      default: _withCtx(() => [
                        _createVNode(_component_ion_accordion, { style: {"--min-height":"24px"} }, {
                          default: _withCtx(() => [
                            _createVNode(_component_ion_item, { slot: "header" }, {
                              default: _withCtx(() => [
                                _createVNode(_component_ion_label, null, {
                                  default: _withCtx(() => _cache[11] || (_cache[11] = [
                                    _createElementVNode("h2", null, [
                                      _createElementVNode("b", null, "4. Check before submit")
                                    ], -1)
                                  ])),
                                  _: 1
                                })
                              ]),
                              _: 1
                            }),
                            _cache[12] || (_cache[12] = _createElementVNode("div", {
                              slot: "content",
                              class: "ion-text-center",
                              style: {"overflow-y":"scroll"}
                            }, [
                              _createElementVNode("iframe", {
                                src: "https://docs.google.com/presentation/d/e/2PACX-1vRPIoEUK064odWPUCaPCkJVf1Zycy2M8ff6WBng_lVRzWunYeC52UOGUUVqcj8V0cAqgQliBky21tqC/embed?start=false&loop=false&delayms=3000&rm=full",
                                frameborder: "0",
                                width: "100%",
                                height: "450px",
                                allowfullscreen: "true",
                                mozallowfullscreen: "true",
                                webkitallowfullscreen: "true"
                              })
                            ], -1))
                          ]),
                          _: 1
                        })
                      ]),
                      _: 1
                    }),
                    _createVNode(_component_ion_item, {
                      onClick: _cache[3] || (_cache[3] = ($event: any) => (_ctx.openBookingModal('bi82ce0b45'))),
                      button: "",
                      detail: ""
                    }, {
                      default: _withCtx(() => [
                        _createVNode(_component_ion_label, null, {
                          default: _withCtx(() => _cache[13] || (_cache[13] = [
                            _createElementVNode("h2", null, [
                              _createElementVNode("b", null, "5. Book an online CV consultation")
                            ], -1)
                          ])),
                          _: 1
                        })
                      ]),
                      _: 1
                    })
                  ]),
                  _: 1
                })
              ], 512), [
                [_vShow, _ctx.section == 1]
              ]),
              _createVNode(_component_ion_modal, {
                "keep-contents-mounted": true,
                "is-open": _ctx.section == 3
              }, {
                default: _withCtx(() => [
                  _createVNode(_component_ion_header, null, {
                    default: _withCtx(() => [
                      _createVNode(_component_ion_toolbar, null, {
                        default: _withCtx(() => [
                          _createVNode(_component_ion_buttons, { slot: "start" }, {
                            default: _withCtx(() => [
                              _createVNode(_component_ion_button, {
                                slot: "icon-only",
                                onClick: _cache[4] || (_cache[4] = ($event: any) => (_ctx.section = 1))
                              }, {
                                default: _withCtx(() => [
                                  _createVNode(_component_ion_icon, { icon: _ctx.arrowBack }, null, 8, ["icon"])
                                ]),
                                _: 1
                              })
                            ]),
                            _: 1
                          }),
                          _createVNode(_component_ion_title, null, {
                            default: _withCtx(() => [
                              _createVNode(_component_ion_label, null, {
                                default: _withCtx(() => _cache[14] || (_cache[14] = [
                                  _createElementVNode("h2", null, [
                                    _createElementVNode("b", null, "Draft bullet points")
                                  ], -1)
                                ])),
                                _: 1
                              })
                            ]),
                            _: 1
                          })
                        ]),
                        _: 1
                      }),
                      _createVNode(_component_ion_toolbar, null, {
                        default: _withCtx(() => [
                          _createVNode(_component_ion_searchbar, {
                            style: {"padding-top":"15px"},
                            mode: "ios",
                            modelValue: _ctx.searchKeyword,
                            "onUpdate:modelValue": _cache[5] || (_cache[5] = ($event: any) => ((_ctx.searchKeyword) = $event)),
                            placeholder: _ctx.t('search'),
                            onKeyup: _cache[6] || (_cache[6] = _withKeys((e) => e.target.blur(), ["enter"]))
                          }, null, 8, ["modelValue", "placeholder"])
                        ]),
                        _: 1
                      })
                    ]),
                    _: 1
                  }),
                  _createVNode(_component_ion_list, null, {
                    default: _withCtx(() => [
                      (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.professionsWithCv, (p) => {
                        return _withDirectives((_openBlock(), _createBlock(_component_ion_item, {
                          key: p.id,
                          button: "",
                          detail: "",
                          onClick: ($event: any) => (_ctx.openCVExamplesModal(p))
                        }, {
                          default: _withCtx(() => [
                            _createVNode(_component_ion_label, null, {
                              default: _withCtx(() => [
                                _createTextVNode(_toDisplayString(p.name), 1)
                              ]),
                              _: 2
                            }, 1024)
                          ]),
                          _: 2
                        }, 1032, ["onClick"])), [
                          [_vShow, !_ctx.searchKeyword || p.name.toLowerCase().includes(_ctx.searchKeyword.toLowerCase().trim())]
                        ])
                      }), 128))
                    ]),
                    _: 1
                  })
                ]),
                _: 1
              }, 8, ["is-open"])
            ]))
      ]),
      _: 1
    })
  ], 64))
}